export interface ISendEmailRequest {
   FromEmail: string;
   ToEmail: Array<string>;
   Subject: string;
   Body: string;
   MemberID: number;
   ToCC: Array<string>;
   ToBCC: Array<string>;
}

export class SendEmailRequest implements ISendEmailRequest {
    FromEmail: string;
    ToEmail: string[];
    Subject: string;
    Body: string;
    MemberID: number;
    ToCC: string[];
    ToBCC: string[];
}
